import { HttpContext, HttpContextToken } from '@angular/common/http';
import { InjectionToken } from '@angular/core';

export interface InterceptorConfig {
  apiUrl: string;
}

export const INTERCEPTOR_CONFIG = new InjectionToken<InterceptorConfig>('INTERCEPTOR_CONFIG');
export const LOADING_TOKEN = new HttpContextToken<string>(() => '');

export const LOADING = 'LOADING';
export const loadingHttpContext: () => HttpContext = () => new HttpContext().set(LOADING_TOKEN, 'LOADING');
